import { Injectable, ComponentRef, Injector, ApplicationRef, createComponent } from '@angular/core';
import { Observable } from 'rxjs';
import { RmsPromptComponent } from '../custom-modules/rms-module/rms-prompt/rms-prompt.component';
import { PromptButton } from '../shared/interfaces/rms-interfaces';
import { RmsPromptRef } from './rms-prompt-ref';

@Injectable({
  providedIn: 'root'
})

export class PromptService {

  private promptRef: ComponentRef<RmsPromptComponent> | null = null;

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector,
  ) { }

  open<T>(options: {
    buttons: PromptButton[],
    promptText?: string,
    htmlPrompt?: any,
    promptInput?: 'text' | 'textarea' | 'select' | 'checkbox' | 'radio' | 'date' | null
    inputRequired?: boolean,
    inputLabel?: string,
    inputOptions?: { [key: string]: any }[]
  }): { ref: RmsPromptRef, instance: RmsPromptComponent, closed$: Observable<any> } {

    // ✅ Create the popup ref to pass down
    const rmsPromptRef = new RmsPromptRef<T>();

    // ✅ Create a child injector that includes the popup ref
    const childInjector = Injector.create({
      providers: [
        { provide: RmsPromptRef, useValue: rmsPromptRef }
      ],
      parent: this.injector
    });
    this.promptRef = createComponent(RmsPromptComponent, {
      environmentInjector: this.appRef.injector,
      elementInjector: childInjector
    });
    console.log(options.inputOptions);
    const instance = this.promptRef.instance;
    const promise = instance.openPrompt({
      text: options.promptText || '',
      htmlPrompt: options.htmlPrompt || '',
      buttons: options.buttons,
      promptInput: options.promptInput,
      inputRequired: options.inputRequired,
      inputLabel: options.inputLabel,
      inputOptions: options.inputOptions
    })


    this.appRef.attachView(this.promptRef.hostView);
    document.body.appendChild(this.promptRef.location.nativeElement);

    const closed$ = instance.closed.asObservable();


    closed$.subscribe(() => this.close());

    return {ref: rmsPromptRef, instance, closed$}
  }
  close() {
    if (this.promptRef) {
      this.appRef.detachView(this.promptRef.hostView);
      this.promptRef.destroy();
      this.promptRef = null;
    }
  }
}
